module.exports = __webpack_public_path__ + "img/free.10bf7e20.jpg";